import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import { IDLE, PENDING } from "const"
import { RrsTemplateLabel } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadRrsTemplateLabelById,
    initRrsTemplateLabel,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface TemplateLabelEditProps {
    labelId: number
}
const TemplateLabelEdit = ({
    labelId = null,
}: TemplateLabelEditProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [label, setLabel] = useState<RrsTemplateLabel>(initRrsTemplateLabel)
    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [reloadEdit, setReloadEdit] = useState(true)

    const reload = () => {
        setReloadEdit(false)
        setTimeout(() => {
            setReloadEdit(true)
        }, 0)
    }

    useEffect(() => {
        if (labelId === 0) {
            setLabel(initRrsTemplateLabel)
            reload()
        } else {
            setLoadState(PENDING)
            LoadRrsTemplateLabelById(labelId).then((res) => {
                setLoadState(IDLE)
                setLabel(res)
                reload()
            })
        }
    }, [])

    if (!label) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{label.id ? `${lang.editLabel} # ${label.id}` : lang.addLabel}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form label={label} />
                }
                {
                    reloadEdit
                    && <Form label={label} />
                }
            </PageContent>
        </Container>
    )
}
export default TemplateLabelEdit
